<a class="block md:px-8" routerLink="dashboard">
    <img class="block min-w-[4rem] max-w-[4rem] sm:min-w-[5rem] sm:max-w-[5rem] w-21" [src]="logoSrc" alt="Logo" />
</a>
